module.exports = __webpack_public_path__ + "static/natalie-e526fe0a9269f7420a4ed5ed0b19c8a8.webp";